"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserReturn = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10.412 14c.205 0 .719.082.506.47-.141.259-.508.769-1.1 1.53H8c-2.667 0-4 1.333-4 4h7.208c1.086.96 1.593 1.523 1.52 1.692-.11.254-.27.308-.61.308H4c-1.333 0-2-.667-2-2 0-4 2.001-6 6.004-6h2.408zm7.3-.379c.354.355.368.925.051 1.327l-.086.097-.956.955h.719l1.887.001h1.852c.6 0 .821.529.821 1 0 .278 0 .999-.82.997H18.06L16.154 18l1.42 1.42c.354.355.369.925.052 1.328l-.086.097c-.371.372-.943.413-1.331.115l-.093-.081-2.831-2.831c-.355-.355-.369-.925-.052-1.328l.086-.097 2.968-2.968c.403-.402 1.04-.418 1.424-.034zM12 2a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z' }))); };
exports.default = SvgUserReturn;
//# sourceMappingURL=UserReturn.js.map